import React from 'react';
import { node } from 'prop-types';
import theme from '../theme/Base';
import PageWrapper from '../components/PageWrapper';
import { ThemeProvider } from 'emotion-theming';
import { HookThemeProvider } from '../context/HookTheme';
import GlobalStyles from '../theme/Global';
import ErrorBoundary from '../components/ErrorBoundary';

Layout.propTypes = {
	children: node
};

export default function Layout({ children }) {
	return (
		<ThemeProvider theme={theme}>
			<HookThemeProvider>
				<GlobalStyles {...theme} />
				<PageWrapper>
					<ErrorBoundary>{children}</ErrorBoundary>
				</PageWrapper>
			</HookThemeProvider>
		</ThemeProvider>
	);
}
